module.exports = __webpack_public_path__ + "img/pc_header_bg.f3c9ac5.webp";